import { Component, Input, inject, OnDestroy, Output, EventEmitter, OnInit } from '@angular/core'
import { SelectionService } from '../../../../services/selection.service'
import { AdditionalQualifier } from '../../../../models/table-state.model'
import { takeUntil, tap } from 'rxjs/operators'
import { Subject } from 'rxjs'

@Component({
  selector: 'jml-lib-selection-filter',
  templateUrl: './selection-filter.component.html',
  styleUrls: ['./selection-filter.component.scss']
})
export class SelectionFilterComponent implements OnInit, OnDestroy {
  @Input() dtoType!: string
  @Input() mainId: number | undefined
  @Input() ownerId: number | undefined
  @Input() ownerType: string | undefined
  @Input() qualifier: string | undefined
  @Input() additionalQualifier: AdditionalQualifier
  @Output() selectionChange = new EventEmitter()

  private destroyed = new Subject()
  private selectionService = inject(SelectionService)

  ngOnInit() {
    // emit change initially to trigger the dynamic table to get the initial count
    // required when a entity table is newly loaded that had selected items before.
    this.selectionChange.emit()
  }
  selectAll() {
    this.selectionService
      .selectAll(this.dtoType, this.mainId, this.ownerId, this.ownerType, this.qualifier, this.additionalQualifier)
      .pipe(
        takeUntil(this.destroyed),
        tap((_) => this.selectionChange.emit())
      )
      .subscribe()
  }

  unselectAll() {
    this.selectionService
      .unselectAll(this.dtoType, this.mainId, this.ownerId, this.ownerType, this.qualifier, this.additionalQualifier)
      .pipe(
        takeUntil(this.destroyed),
        tap((_) => this.selectionChange.emit())
      )
      .subscribe()
  }

  ngOnDestroy() {
    this.destroyed.next()
    this.destroyed.complete()
  }
}
